import { IconArrowLeft } from '@iwoca/icons';
import { Trans, useLingui } from '@lingui/react/macro';

import styles from './ProgressBar.module.css';

type TProps = {
  index: number;
  total: number;
  onBack?: () => void;
};

export const ProgressBar = ({ index, total, onBack }: TProps) => {
  const { t } = useLingui();
  const completed = index - 1;
  const percent = Math.round((completed / total) * 100);

  return (
    <div className={styles.container}>
      <div className={styles.meta}>
        <div className={styles.metaLeft}>
          {onBack && (
            <button
              type="button"
              className={styles.back}
              onClick={onBack}
              aria-label={t`Back`}
            >
              <IconArrowLeft />
            </button>
          )}
          <span className={styles.stepLabel}>
            <Trans>
              Step <strong>{index}</strong> of {total}
            </Trans>
          </span>
        </div>
        <span className={styles.percent}>{percent}%</span>
      </div>
      <div
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
        className={styles.segments}
      >
        {Array.from({ length: total }, (_segment, segmentIndex) => {
          const isDone = segmentIndex < completed;
          return (
            <span
              key={segmentIndex}
              className={`${styles.segment} ${isDone ? styles.segmentDone : ''}`}
            />
          );
        })}
      </div>
    </div>
  );
};
